import { useEffect, useState } from "react";
import { ScrollText } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import axios, { API } from "@/lib/api";
import LoadingScreen from "@/components/shared/LoadingScreen";
import EmptyState from "@/components/shared/EmptyState";

export default function AdminAuditLog() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/audit-log`).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="admin-audit-log-page" className="space-y-5">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#1F2937]">Audit Log</h1>
        <p className="text-sm text-[#64748B]">Riwayat aktivitas penting dalam sistem.</p>
      </div>

      {items === null ? <LoadingScreen /> : items.length === 0 ? (
        <EmptyState icon={ScrollText} title="Belum ada aktivitas" description="Aktivitas administratif akan tercatat di sini." />
      ) : (
        <div className="overflow-x-auto rounded-xl border border-slate-100 bg-white">
          <Table data-testid="admin-audit-log-table">
            <TableHeader><TableRow><TableHead>Waktu</TableHead><TableHead>Pengguna</TableHead><TableHead>Tindakan</TableHead><TableHead>Objek</TableHead><TableHead>IP</TableHead></TableRow></TableHeader>
            <TableBody>
              {items.map((l) => (
                <TableRow key={l.id} data-testid={`admin-audit-log-row-${l.id}`}>
                  <TableCell className="text-[#64748B]">{new Date(l.created_at).toLocaleString("id-ID")}</TableCell>
                  <TableCell className="font-medium text-[#1F2937]">{l.user_name}</TableCell>
                  <TableCell className="text-[#64748B]">{l.action}</TableCell>
                  <TableCell className="text-[#64748B]">{l.object_type}</TableCell>
                  <TableCell className="text-[#64748B]">{l.ip_address}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
